import { Box, Typography } from "@mui/material";
import LinkRouter from "../navigation/LinkRouter";
import { Lock } from "lucide-react";

export default ({
  secretName,
  familyRef,
  creatorName,
}: {
  secretName: string;
  secretRef: string;
  familyRef: string;
  creatorName: string;
}) => {
  return (
    <LinkRouter to={`/families/${encodeURIComponent(familyRef)}#tab-secrets`}>
      <Box
        sx={{
          backgroundColor: "#FFF",
          border: "1px solid #EAEBEC",
          borderRadius: "12px",
          display: "flex",
          padding: "12px 16px",
          width: "100%",
          gap: "8px",
        }}
      >
        <Lock width={24} height={24} color="#6B6E7B" />
        <Typography
          variant="bodySmall"
          color="text.primary"
          sx={{
            width: "100%",
          }}
        >
          {creatorName} added a new secret:{" "}
          <Typography
            color="primary.main"
            component="span"
            sx={{ fontWeight: "600", fontSize: "14px" }}
          >
            {secretName}
          </Typography>
        </Typography>
      </Box>
    </LinkRouter>
  );
};
